<template>
    <div class="bestin mt-3 container py-3">

        <div class="row">
            <div class="col-12 col-md-6">
                <p class="c-link">-------------- More About Us</p>
                <h3>
                    <strong>Advance accounting & co</strong> - Are Your Premier Taxation Service Solution
                </h3>
                <!-- <div class="founder-card mb-3 p-2">
                    <img src="@/assets/NewLogo.png" alt="logo" height="20">
                    Founder card
                </div> -->
                <!-- <img src="@/assets/hero.jpeg" alt="team" class="w-100"> -->
            </div>
            <div class="col-12 col-md-6">
                <!-- <img src="@/assets/hero.png" alt="team" class="w-100"> -->
                <carousel :per-page="1" :navigate-to="someLocalProperty" :mouse-drag="false" autoplay="true" loop="true"
                    class="mt-5">
                    <slide>
                        <div class="office-image1 p-4 "></div>
                    </slide>
                    <slide>
                        <div class="office-image2 p-4 "></div>
                    </slide>
                    <slide>
                        <div class="office-image3 p-4 "></div>
                    </slide>
                    <slide>
                        <div class="office-image4 p-4 "></div>
                    </slide>
                </carousel>
                <p class="my-3">There are many options when it comes to tax services, but we stand out by offering
                    personalized,
                    professional, and reliable solutions tailored to meet your needs. Our approach is built on trust and
                    integrity, ensuring that your tax matters are handled efficiently and accurately.</p>

                <div class="">
                    <h4>Our Expertise Includes:</h4>
                    <div class="expertise">
                        <div class="" v-for="(item, index) in expertise" :key="index">
                            <h7>* {{ item.title }}</h7>
                            <p>&nbsp;&nbsp;&nbsp;{{ item.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'bestinComponent',
    data() {
        return {
            expertise: [
                {
                    title: 'Comprehensive Taxation Services',
                    description: 'Tailored solutions for individuals and businesses.',
                },
                {
                    title: 'Dedicated Professionals',
                    description: 'Our team is committed to providing exceptional service and support.',
                },
                {
                    title: 'Strategic Business Planning & Growth',
                    description: 'Helping you navigate complex financial decisions with clarity and confidence.',
                },
                {
                    title: '99.9% Client Satisfaction',
                    description: 'We prioritize your needs and satisfaction, delivering results you can trust.',
                    percentage: '99.9%',
                },
            ],
        };
    },
    components: {
        Carousel,
        Slide
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.VueCarousel-pagination {
    display: none !important;
}

.founder-card {
    background-color: #fcf2e875;
    border-radius: 12px;
}

.office-image1 {
    background-image: url("@/assets/office1.jpeg");
    background-size: cover;
    background-position: center;
    height: 250px;

    @media screen and (max-width: 480px) {
        height: 180px !important;
    }
}

.office-image2 {
    background-image: url("@/assets/office2.jpeg");
    background-size: cover;
    background-position: center;
    height: 250px;

    @media screen and (max-width: 480px) {
        height: 180px !important;
    }
}

.office-image3 {
    background-image: url("@/assets/office3.jpeg");
    background-size: cover;
    background-position: center;
    height: 250px;

    @media screen and (max-width: 480px) {
        height: 180px !important;
    }
}

.office-image4 {
    background-image: url("@/assets/office4.jpeg");
    background-size: cover;
    background-position: center;
    height: 250px;

    @media screen and (max-width: 480px) {
        height: 180px !important;
    }
}
</style>